import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment-timezone";
import FetchUserDetails from "../../components/payment-link-system/FetchUserDetails";
import { registerUser } from "../../redux/reducers/postApiSlice";
import { showConfirmAlert } from "../../components/components-react/ReactAlert";
import { validatemap_form_email } from "../../exports/Validations";
import { fetchUserDetailsByMobileData } from "../../redux/reducers/apiSlice";
import { useUpdateForm } from "../../data/Queries";
import { usersGetKey, userUpdate } from "../../data/ApiEndpoints";
import AddSubscription from "./AddSubscription";

const SubscriptionUserDetails = ({
  decryptedText,
  createSubsFormData,
  setCreateSubsFormData,
  createSubsFormErrors,
  gstTableValues,
  onClickSubmit,
  isSubmitting,
  currentStep,
  setCurrentStep,
}) => {
  const dispatch = useDispatch();
  const { userDetailsByMobile } = useSelector((state) => state.api);
  const { mutateAsync: updateUser } = useUpdateForm({
    url: userUpdate,
    key: usersGetKey,
    token: decryptedText?.token,
  });

  const initialUserFormData = {
    mobile: "",
    email: "",
    name: "",
    gender: "",
    user_id: "",
    dob: "",
  };
  const [userFormData, setUserFormData] = useState(initialUserFormData);
  const [isUserExist, setIsUserExist] = useState(false);
  const [isFetchUserDetaillsByMobile, setIsFetchUserDetaillsByMobile] =
    useState(false);
  const [isUpdateRequired, setIsUpdateRequired] = useState(null);
  const [isRegistering, setIsRegistering] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  const onClickFetchUserDetails = () => {
    if (isFetching) return;
    if (userFormData.mobile && userFormData.mobile?.length === 10) {
      const handleConfirm = async () => {
        setIsFetching(true);
        setIsFetchUserDetaillsByMobile(true);
        try {
          await dispatch(
            fetchUserDetailsByMobileData({
              userMobile: userFormData.mobile,
              token: decryptedText?.token,
            })
          );
        } finally {
          setIsFetching(false);
        }
      };

      showConfirmAlert(
        handleConfirm,
        `Is the entered ${userFormData.mobile} number correct?`
      );
    } else {
      toast.error("Please Enter Mobile Number! (Number Must Be 10 Digit)");
      setIsFetchUserDetaillsByMobile(false);
    }
  };

  const onClickRegisterUser = (isUpdateRequired) => {
    if (isRegistering) return;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const nameRegex = /^[A-Za-z\s]+$/;
    const yopmailRegex = /@yopmail\.com$/i;
    const mobileRegex = /^\d{10}$/;
    const today = moment().tz("Asia/Kolkata").startOf("day");

    if (
      !userFormData.mobile ||
      !userFormData.email ||
      !userFormData.name ||
      !userFormData.gender?.value
    ) {
      toast.error("Please Ensure All The Fields Are Filled!");
      return;
    }

    if (!nameRegex.test(userFormData.name)) {
      toast.error("Name should only contain letters!");
      return;
    }

    if (!emailRegex.test(userFormData.email)) {
      toast.error("Please Enter Correct Format of Email!");
      return;
    }

    if (yopmailRegex.test(userFormData.email)) {
      toast.error("Yopmail is not allowed!");
      return;
    }

    if (!mobileRegex.test(userFormData.mobile)) {
      toast.error("Please Enter Correct Format of Mobile Number!");
      return;
    }

    if (userFormData.dob) {
      const enteredDOB = moment
        .tz(userFormData.dob, "Asia/Kolkata")
        .startOf("day");
      const age = today.diff(enteredDOB, "years");

      if (enteredDOB.isAfter(today)) {
        toast.error("DOB cannot be in the future!");
        return;
      } else if (age < 10) {
        toast.error("Member must be at least 10 years old!");
        return;
      }
    }

    const userData = {
      uid: isUpdateRequired ? userFormData?.uid : "",
      name: userFormData.name,
      mobile: userFormData.mobile,
      email: userFormData?.email,
      gender: userFormData.gender?.value,
      dob: userFormData.dob || "",
      is_web: 1,
      account_type: "member",
      otp: "otp",
      referral_code: "",
      n_token: "n_token",
    };

    if (isUpdateRequired) {
      handleUpdateUser(userData);
    } else {
      handleRegisterUser(userData, decryptedText?.token);
    }
  };

  // Move to Step 2 with user data
  const proceedToStep2 = (userData) => {
    setUserFormData(userData);

    // Auto-select user in subscription form
    setCreateSubsFormData((prev) => ({
      ...prev,
      selectedUser: {
        label: `${userData?.name} / ${userData?.mobile}`,
        value: userData?.user_id || userData?.uid,
      },
    }));

    // Move to step 2
    setCurrentStep(2);
    setIsUserExist(false);
    setIsUpdateRequired(null);
  };

  async function handleUpdateUser(userData) {
    async function handleUpdateUserConfirm() {
      setIsRegistering(true);
      try {
        const formdata = new FormData();

        Object.entries(userData).forEach(([key, value]) => {
          formdata.append(key, value);
        });

        const { status, message, data } = await updateUser({ data: formdata });

        if (status) {
          toast.success(message);
          const updatedUser = data[0];
          proceedToStep2(updatedUser);
        } else {
          toast.error(message);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsRegistering(false);
      }
    }

    showConfirmAlert(
      handleUpdateUserConfirm,
      `Are you sure you want to update the user details?`
    );
  }

  function handleBack() {
    setUserFormData(initialUserFormData);
    setIsUserExist(false);
    setIsFetchUserDetaillsByMobile(false);
    setIsUpdateRequired(null);
  }

  const handleRegisterUser = async (userData, TOKEN) => {
    setIsRegistering(true);
    try {
      const actionResult = dispatch(registerUser({ userData, TOKEN }));
      const result = await actionResult;

      if (result?.payload?.status && result?.payload?.data) {
        const registeredUser = result.payload.data;
        proceedToStep2(registeredUser);
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage);
      }
    } catch (error) {
      console.log("handleRegisterUser ERROR => ", error);
    } finally {
      setIsRegistering(false);
    }
  };

  useEffect(() => {
    if (isFetchUserDetaillsByMobile && userDetailsByMobile?.status) {
      const { email, gender, account_type } = userDetailsByMobile?.data?.[0];

      const isEmailInvalid = !validatemap_form_email(email);
      const isGenderMissing = !gender;

      if (account_type !== "member") {
        toast.error(
          `This Mobile Number does not belong to a member. It's a ${account_type} account!`
        );
        return;
      } else if (isEmailInvalid || isGenderMissing) {
        setIsUpdateRequired({
          isEmailRequired: !validatemap_form_email(email) ? email : false,
          isGenderRequired: !gender ? true : false,
        });
        setUserFormData(userDetailsByMobile?.data?.[0]);

        let errorMessage = "Please update the following fields: ";
        if (isEmailInvalid) errorMessage += "Email ";
        if (isEmailInvalid && isGenderMissing) errorMessage += "and ";
        if (isGenderMissing) errorMessage += "Gender.";

        toast.error(errorMessage);
      } else {
        // User exists with valid data - proceed to step 2
        const existingUser = userDetailsByMobile?.data?.[0];
        proceedToStep2(existingUser);
      }
    } else if (
      isFetchUserDetaillsByMobile &&
      userDetailsByMobile?.status === false
    ) {
      setIsUserExist(true);
      toast.error(userDetailsByMobile?.message);
    }
  }, [userDetailsByMobile]);

  // Reset state when step changes to 1
  useEffect(() => {
    if (currentStep === 1) {
      setUserFormData(initialUserFormData);
      setIsUserExist(false);
      setIsFetchUserDetaillsByMobile(false);
      setIsUpdateRequired(null);
    }
  }, [currentStep]);

  return (
    <>
      {/* Step 1: Mobile Number Input */}
      {currentStep === 1 && (
        <FetchUserDetails
          isUserExist={isUserExist}
          userFormData={userFormData}
          setUserFormData={setUserFormData}
          onClickFetchUserDetails={onClickFetchUserDetails}
          onClickRegisterUser={onClickRegisterUser}
          handleBack={handleBack}
          isUpdateRequired={isUpdateRequired}
          isDobOptional={true}
          isRegistering={isRegistering}
          isFetching={isFetching}
        />
      )}

      {/* Step 2: Subscription Form */}
      {currentStep === 2 && (
        <AddSubscription
          decryptedText={decryptedText}
          createSubsFormData={createSubsFormData}
          setCreateSubsFormData={setCreateSubsFormData}
          createSubsFormErrors={createSubsFormErrors}
          gstTableValues={gstTableValues}
          onClickSubmit={onClickSubmit}
          isSubmitting={isSubmitting}
          isUserPreSelected={true}
          preSelectedUserData={userFormData}
        />
      )}
    </>
  );
};

export default SubscriptionUserDetails;
